import React from "react";
import { GameContext } from "./GameContext";

export const useGame = () => {
  return React.useContext(GameContext);
};

export * from "./GameProvider";
